import clevertap from "clevertap-web-sdk";
import { useMemo, useState } from "react";

//scss
import "./style.scss";

//components
import { ColorRing } from "react-loader-spinner";
import AllAmenities from "../AllAmenities";
import IconText from "../Icon-text";
import ListingTwoColGrid from "../ListingTwoColGrid";
import ListingTwoColView from "../ListingTwoColView";
import { useTheme } from "components/ListingNew/ListingTheme";

const ListingAmenites = (
	{ amenityList, listingamenities, notPresent, color },
	...props
) => {
	const amenitiesData = useMemo(
		() => parseAmenities(amenityList, listingamenities),
		[amenityList],
	);

	//showing only six amenities on listing page
	const amenities = amenitiesData.list.map((item, index) => {
		if (index < 6 && item.title) {
			return <IconText {...item} key={index} type={"amen"} />;
		}
		return null;
	});

	//allAmenities state
	const [openPopup, setOpenPopup] = useState(false);

	const theme = useTheme();

	return (
		<>
			<AllAmenities
				amenityList={amenitiesData.categoryList}
				notPresent={notPresent}
				open={openPopup}
				setOpen={setOpenPopup}
			/>
			<div className="row2-container">
				<ListingTwoColGrid list={amenities} />
				<div className="listing__button__new__wrapper">
					{" "}
					<button
						aria-label="view-all-amenities"
						className="listing__button__new__all"
						style={{ marginTop: "40px", ...theme.borderBtn }}
						onClick={() => {
							clevertap.event.push("viewAllAmenities_btn_listing_page", {
								location: window.location.pathname.split("/")[2],
								timestamp: new Date(),
							});
							setOpenPopup(true);
						}}
					>
						View all Amenities
					</button>
					{(Object.keys(amenityList || {}).includes("19") ||
						Object.keys(amenityList || {}).includes("14")) && (
						<button
							aria-label="view-all-amenities"
							className="listing__button__new__all"
							style={{ marginTop: "40px", ...theme.borderBtn }}
							onClick={() => {
								window.open(
									"https://ik.imagekit.io/5tgxhsqev/pdf/Pet%20Contract.pdf?updatedAt=1706534926948",
									"_blank",
								);
							}}
						>
							Pet Contract
						</button>
					)}
				</div>
			</div>
		</>
	);
};

const parseAmenities = (amenityList, amenityCategoryList) => {
	let list = [];
	let categoryList = [];
	try {
		list = Object.entries(amenityList).map(([key, value]) => ({
			id: key,
			title: value,
		}));
		for (const [key, value] of Object.entries(amenityCategoryList)) {
			categoryList.push({
				category: key,
				amenities: value,
			});
		}
	} catch (e) {}
	return {
		list: list,
		categoryList: categoryList,
	};
};

export default ListingAmenites;
